
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/SelectContent';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<ul role=\"tree\" tabindex=\"0\" aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.select_content")
  },data:data},helper ? helper.call(depth0, "content_migrations.select_content.select_content_label", "Select content, Use the up and down arrow keys to navigate through the tree. Press right to expand and left to collapse.", options) : helperMissing.call(depth0, "t", "content_migrations.select_content.select_content_label", "Select content, Use the up and down arrow keys to navigate through the tree. Press right to expand and left to collapse.", options)))
    + "'>\n  <li class=\"form-dialog-content\">\n</ul>\n\n<div class=\"form-controls\">\n  <input id=\"cancelSelect\" class=\"btn btn-default\" type=\"button\" value='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.select_content")
  },data:data},helper ? helper.call(depth0, "content_migrations.select_content.cancel_btn", "Cancel", options) : helperMissing.call(depth0, "t", "content_migrations.select_content.cancel_btn", "Cancel", options)))
    + "'/>\n  <input id=\"selectContentBtn\" class=\"btn btn-primary\" type=\"submit\" value='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.select_content")
  },data:data},helper ? helper.call(depth0, "content_migrations.select_content.select_content_btn", "Select Content", options) : helperMissing.call(depth0, "t", "content_migrations.select_content.select_content_btn", "Select Content", options)))
    + "' disabled/>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  